import { render, staticRenderFns } from "./leave-tracker-report.vue?vue&type=template&id=2bd1989b"
import script from "./leave-tracker-report.vue?vue&type=script&lang=js"
export * from "./leave-tracker-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports